import { Column } from "@tanstack/react-table";
import ColumnSortHeaderButton from "../shared/ColumnSortHeaderButton";
import { LeadRecordType, MemberRecordType, StaffRecordType } from "../../types";

type ColumnTableHeaderProps = {
  hasRowsSelected: boolean;
  column: Column<MemberRecordType | LeadRecordType | StaffRecordType>;
  title: string;
  width: string;
};

export default function ColumnTableHeader({
  hasRowsSelected,
  column,
  title,
  width,
}: ColumnTableHeaderProps) {
  return (
    <div className="tw-px-3 tw-py-1 max-sm:tw-hidden" style={{ width }}>
      <div className="tw-flex tw-items-center tw-h-[38px]">
        <ColumnSortHeaderButton
          column={column}
          title={title}
          hasRowsSelected={hasRowsSelected}
        />
      </div>
    </div>
  );
}
